// @ts-ignore translations is defined in "includes/_translations.twig" and in component templates
export const lang: Map<string, string> = translations;
